<template>
    <div :style="{fontSize:fSize+'px'}">
        <slot></slot>
    </div>
</template>

<script>

    let defaultWidth = 1400,
        defaultFont = 16,
        minWidth = 768,
        minHeight = 600,
        defaultHeight = 800;

    export default {
        name: 'Resize',
        mounted () {
            window.addEventListener('resize',this.onResize.bind(this));
            this.$root.$emit('onResize');
        },

        data () {
            return {
                vW:  window.innerWidth,
                vH:  window.innerHeight,
                ratio: 1
            }
        },

        computed: {
            fSize () {
                let fSize = 16;
                if (!this.$root.isMobile){
                    fSize = 16 * Math.min(Math.max(minWidth, this.vW) / defaultWidth, Math.max(minHeight, this.vH) / defaultHeight);
                    this.ratio = Math.min(Math.max(minWidth, this.vW) / defaultWidth, Math.max(minHeight, this.vH) / defaultHeight);
                }
                return fSize;
            }
        },

        methods: {
            onResize () {
                this.$root.$emit('onResize');
                this.vW = window.innerWidth;
                this.vH = window.innerHeight;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// Resize.vue?213c9df8